/* Pure Smart Cart assignment; no page/widget allocation or cart mutation. */
(function(scope){'use strict';
 function bucket(sid,epoch){var h=0x811c9dc5,s='smart-cart-v1:'+epoch+':'+sid;for(var i=0;i<s.length;i++){h^=s.charCodeAt(i);h=Math.imul(h,0x01000193)>>>0;}return h%10000;}
 function decide(c,sid,cart,lease,forced,prior){
  var result={surface:'smart_cart',provider:'rebuy',reason:'control-unavailable',bucket:bucket(sid,c.epoch),epoch:c.epoch};
  if(!cart||!Array.isArray(cart.items)){result.reason='cart-unavailable';return result;}
  if(!lease||forced){result.reason=forced?'session-rollback':'control-unavailable';return result;}
  var a=cart.attributes||{};
  if(cart.items.length){
   if(a._malezia_sc_epoch===c.epoch&&['malezia','rebuy'].indexOf(a._malezia_sc_provider)>=0){result.provider=a._malezia_sc_provider;result.reason='existing-cart-owner';}
   else result.reason='existing-unassigned-cart';
   return result;
  }
  // Empty carts use current deterministic allocation. Incidental startup fallback
  // is not a cohort assignment; nonempty ownership and explicit rollback above win.
  result.reason='bucket';result.provider=result.bucket<lease.percent*100?'malezia':'rebuy';return result;
 }
 function attributes(sid,c,d,qa){return {_mm_sid:sid,_malezia_sc_sid:sid,_malezia_sc_epoch:c.epoch,_malezia_sc_provider:d.provider,_malezia_sc_source:c.source,_malezia_sc_qa:qa?'true':'false',_malezia_sc_rules:c.rulesVersion};}
 scope.MaleziaSmartCartPolicy=Object.freeze({bucket:bucket,decide:decide,attributes:attributes});
})(typeof window==='undefined'?globalThis:window);
